module.exports = __webpack_public_path__ + "img/shareHomeIcon.6edcf092.svg";